module.exports = __webpack_public_path__ + "static/media/smoothsole-logo.40617068.jpg";